import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const FacebookSolidSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { d: "M8.84841 14.9454C12.3143 14.5267 15 11.5752 15 7.99634C15 4.13034 11.866 0.996338 8 0.996338C4.13401 0.996338 1 4.13034 1 7.99634C1 11.2792 3.25987 14.0342 6.30881 14.7907V10.1355H4.86401V7.9963H6.30881V7.0723C6.30881 4.6895 7.38681 3.5863 9.72481 3.5863C10.1672 3.5863 10.9316 3.6731 11.2452 3.7599V5.7003C11.08 5.6835 10.7916 5.6751 10.436 5.6751C9.28801 5.6751 8.84561 6.1091 8.84561 7.2403V7.9963H11.1332L10.7412 10.1355H8.84841V14.9454Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const FacebookSolidSize16 = hoc(forwardRef(FacebookSolidSize16Component), 'FacebookSolidSize16');

export { FacebookSolidSize16 as default };
//# sourceMappingURL=FacebookSolidSize16.js.map
